import orderEndpoints from "@/api/orders";
import { _ } from 'vue-underscore'
import { OK, CREATED } from '@/constants'
export const deepCopy = (obj) => {
  return Object(JSON.parse(JSON.stringify(obj)))
}

export const tryExceptAwait = async (func, payload) => {
  try {
    if (payload) {
      return await func(...payload)
    } else {
      return await func()
    }
  } catch (error) {
    console.error(error)
    return error
  }
}

// get image with fallback in case it does not exist
export const requireAssetWithFallback = (imgSrc) => {
  try {
    return require(`@/assets/${imgSrc}`)
  } catch {
    return require(`@/assets/images/noimage.png`)
  }
}

export const capitalizeFirstLetter = (string) => {
  return string
    ? string.charAt(0).toUpperCase() + string.slice(1)
    : null
}


export const createArticleOrder = async (articleType, articleData) => {
  const { data, status } = await tryExceptAwait(
    orderEndpoints.createArticleOrder,
    [{ articleType }, articleData]
  )
  return status === CREATED ? data.order_number : null
}


export const createRailRodOrder = async (articleType, orderData) => {
  const { data, status } = await tryExceptAwait(
    orderEndpoints.createArticleOrder,
    [{ articleType }, orderData]
  )
  return status === CREATED ? data.order_number : null
}
export const updateArticleOrder = async (orderNumber, articleType, articleData) => {
  const { status } = await tryExceptAwait(
    orderEndpoints.updateArticleOrder,
    [{ orderNumber, articleType }, articleData]
  )
  return status === OK
}

export const loadArticleOrderData = async ({orderNumber}) => {
  const endpoint = isNaN(parseInt(orderNumber))
    ? orderEndpoints.getArticleOrderByHash
    : orderEndpoints.getArticleOrder
  const {data, status} = await tryExceptAwait(
    endpoint, [{article_order_numbers: [orderNumber]}]
  )
  return {data, status}
}

export const hasEqualSize = (size1, size2) => {
  // check if two size definition objects with
  // min, max and increment are equal
  const sizeObject1 = _.isEmpty(size1) ? {} : size1
  const sizeObject2 = _.isEmpty(size2) ? {} : size2
  return (
    sizeObject1.min === sizeObject2.min
    && sizeObject1.max === sizeObject2.max
    && sizeObject1.increment === sizeObject2.increment
  )
}
